import axios from "axios";

export const backendUrl = process.env.REACT_APP_BACKEND_URL;
export const API = `${backendUrl}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const setToken = (t) => {
  if (t) {
    localStorage.setItem("pi_token", t);
    api.defaults.headers.common.Authorization = `Bearer ${t}`;
  } else {
    localStorage.removeItem("pi_token");
    delete api.defaults.headers.common.Authorization;
  }
};

const _saved = typeof localStorage !== "undefined" ? localStorage.getItem("pi_token") : null;
if (_saved) api.defaults.headers.common.Authorization = `Bearer ${_saved}`;

api.interceptors.request.use((config) => {
  const t = localStorage.getItem("pi_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const brl = (v) =>
  (v == null || isNaN(v) ? "—" : Number(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" }));

export const fmtDate = (s) => {
  if (!s) return "—";
  try {
    const d = new Date(s);
    if (isNaN(d)) return "—";
    return d.toLocaleDateString("pt-BR");
  } catch {
    return "—";
  }
};

export const fmtDateTime = (s) => {
  if (!s) return "—";
  try {
    const d = new Date(s);
    if (isNaN(d)) return "—";
    return d.toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return "—";
  }
};

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Erro inesperado";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
};
